import { Icon as ChakraIcon, type IconProps } from '@chakra-ui/react';
import { createContext, useContext, type FC } from 'react';

import { type iconOptions } from '$/components/common/Icon/IconOptions';

export type AvailableIcons = (typeof iconOptions)[number];

interface Props extends IconProps {
  icon: AvailableIcons;
  iconPath?: string;
}

const defaultIconPath = `${import.meta.env.BASE_URL}/icons/icons.svg`.replace(
  '//',
  '/',
);
const IconPathContext = createContext(defaultIconPath);
export const IconPathProvider = IconPathContext.Provider;

export const Icon: FC<Props> = ({
  icon,
  iconPath,
  className = '',
  ...rest
}) => {
  const configuredIconPath = useContext(IconPathContext);

  return (
    <ChakraIcon
      className={className}
      w='20px'
      h='20px'
      fill='currentcolor'
      pointerEvents='none'
      {...rest}
    >
      <use xlinkHref={`${iconPath ?? configuredIconPath}#${icon}`} />
    </ChakraIcon>
  );
};
